<div class="flex flex-col gap-6">
    <!-- First Row: Week and Month Progress -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <!-- Week Progress -->
        <div class="flex flex-col items-center h-full">
            <div class="flex items-center gap-2">
                <div class="text-xl font-semibold">This Week's Call Goal</div>
                <fa-icon [icon]="icons.regular.faCircleInfo" class="cursor-help text-gray-500 text-lg" 
                   pTooltip="Weekly call statistics"
                   tooltipPosition="top"></fa-icon>
            </div>
            <div class="flex flex-col items-center gap-4 py-4">
                <div>
                    <p-knob 
                        [ngModel]="weekProgress().percentage"
                        [readonly]="true"
                        [size]="120"
                        [strokeWidth]="10"
                        valueColor="rgba(232, 123, 38, 0.7)"
                        valueTemplate="{value}%"
                    ></p-knob>
                </div>
                <div class="text-center">
                    <div class="text-2xl font-light">{{weekProgress().value | number}}</div>
                    <div class="text-sm text-gray-600">Goal: {{weekProgress().goal | number}}</div>
                </div>
            </div>
        </div>

        <!-- Month Progress -->
        <div class="flex flex-col items-center h-full">
            <div class="flex items-center gap-2">
                <div class="text-xl font-semibold">{{currentMonth}} Call Goal</div>
                <fa-icon [icon]="icons.regular.faCircleInfo" class="cursor-help text-gray-500 text-lg" 
                   pTooltip="Monthly call statistics"
                   tooltipPosition="top"></fa-icon>
            </div>
            <div class="flex flex-col items-center gap-4 py-4">
                <div>
                    <p-knob 
                        [ngModel]="monthProgress().percentage"
                        [readonly]="true"
                        [size]="120"
                        [strokeWidth]="10"
                        valueColor="rgba(232, 123, 38, 0.7)"
                        valueTemplate="{value}%"
                    ></p-knob>
                </div>
                <div class="text-center">
                    <div class="text-2xl font-light">{{monthProgress().value | number}}</div>
                    <div class="text-sm text-gray-600">Goal: {{monthProgress().goal | number}}</div>
                </div>
            </div>
        </div>
    </div>

    <!-- Second Row: Year Progress -->
    <div class="flex justify-center">
        <div class="flex flex-col items-center h-full">
            <div class="flex items-center gap-2">
                <div class="text-xl font-semibold">{{currentYear}} Call Goal</div>
                <fa-icon [icon]="icons.regular.faCircleInfo" class="cursor-help text-gray-500 text-lg" 
                   pTooltip="Yearly call statistics"
                   tooltipPosition="top"></fa-icon>
            </div>
            <div class="flex flex-col items-center gap-4 py-4">
                <div>
                    <p-knob 
                        [ngModel]="yearProgress().percentage"
                        [readonly]="true"
                        [size]="120"
                        [strokeWidth]="10"
                        valueColor="rgba(232, 123, 38, 0.7)"
                        valueTemplate="{value}%"
                    ></p-knob>
                </div>
                <div class="text-center">
                    <div class="text-2xl font-light">{{yearProgress().value | number}}</div>
                    <div class="text-sm text-gray-600">Goal: {{yearProgress().goal | number}}</div>
                </div>
            </div>
        </div>
    </div>
</div> 